import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';

import { ReportConfig } from './report.model';
import { ReportService } from './report.service';
import { ReportExportService } from './report-export.service';


@Component({
  standalone: false,
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {
  @Input() config!: ReportConfig;

  data: any[] = [];
  loading = false;
  form!: FormGroup;
  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<any>();

  constructor(private reportService: ReportService, private fb: FormBuilder, private exportService: ReportExportService) { }

  ngOnInit(): void {
    this.buildForm();
    this.displayedColumns = this.config.columns.map(c => c.field);
    this.loadData();
  }

  buildForm() {
    const group: any = {};

    this.config.filters?.forEach(filter => {
      group[filter.field] = [''];
    });

    this.form = this.fb.group(group);
  }

  applyFilters() {
  this.loadData(this.form.value);
}

  loadData(params?: any) {
  this.loading = true;

  this.reportService.getReportData(
    this.config.apiEndpoint,
    params
  ).subscribe(res => {
    this.data = res;
    this.loading = false;
  });
}

exportExcel() {
  this.exportService.exportToExcel(
    this.dataSource.data,
    this.config.title
  );
}

}
